import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "multiple-choice",
  "use": "multiple-choice-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"multiple-choice\"><path fill-rule=\"evenodd\" d=\"M7.5 12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5A4.502 4.502 0 0 1 7.5 12Zm4.5 7c3.867 0 7-3.133 7-7 0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7Zm0-16c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol